import Konva from "konva";
import { PanelAutofillArea } from "../input/PanelAutofillArea";
import { SC_Input } from "../input/SC_Input";
import { MountingSystem } from '../mountsys/MountingSystem';
import { MountingType } from '../mountsys/MountingType';
import { DrawRoofForPanel } from '../panel/drawRoofForPanel';
import { ModGroup } from '../panel/ModGroup';
import { ModList } from '../panel/ModList';
import { Modul } from '../panel/Modul';
import { AreaFinder } from "../roof/areaFinder";
import { RoofShape } from '../roof/RoofShape';
import { RoofType } from '../roof/RoofType';
import { Global } from '../utilities/global';
import { Statics } from '../utilities/statics';
import { getCanvasLine } from "./getCanvas";

export default class DrawPanels {

    drawPanels(list: any[]) {
        let panelImg = new Image();
        panelImg.onload = () => {
            let img = new Konva.Image({
                image: panelImg,
                width: list[0].w,
                height: list[0].h,
                draggable: false,
                x: 0,
                y: 0
            });
            this.drawPanelsHandler(img, list);
        };
        // panelImg.src = "./static/asset/panel-mono.jpg";
        panelImg.src = document.baseURI + '/assets/images/mono.jpg';
    }
    drawPanelsHandler(panelImg: Konva.Image, list: any[]) {
        const width = 0, height = 0, x = 0, y = 0;
        let tStart = +new Date();

        // var haveIntersection = (r1: any, r2: any) => {
        //     return !(
        //         r2.x > r1.x + r1.width ||
        //         r2.x + r2.width < r1.x ||
        //         r2.y > r1.y + r1.height ||
        //         r2.y + r2.height < r1.y
        //     );
        // }
        var lastPos: any;
        for (let i = 0; i < list.length; i++) {
            const panelId = "panel" + ++Modul.panelCount;
            const panel = panelImg.clone();
            var group = new Konva.Group({
                draggable: false,
                x: list[i].x,
                y: list[i].y,
                width: list[i].w,
                height: list[i].h,
                name: Global.panelsOnRoof,
                id: panelId,
            });
            var border1 = getCanvasLine({
                points: [1, 1, list[i].w - 1, 1, list[i].w - 1, list[i].h - 1, 1, list[i].h - 1, 1, 1],
                stroke: '#00ff89',
                strokeWidth: 2,
                opacity: 0,
                name: 'border1'
            });
            var border = getCanvasLine({
                points: [4, 4, list[i].w - 4, 4, list[i].w - 4, list[i].h - 4, 4, list[i].h - 4, 4, 4],
                stroke: '#00ff89',
                strokeWidth: 4,
                opacity: 0,
                name: 'border'
            });
            const sRange = !Global.toggleBoundaryArea ? AreaFinder.getAreaByModule(group.getAttrs()) : "h";
            let invalid_panel_status: boolean = false;
            if (SC_Input.iMountSys != MountingSystem.SOL50_PREM_IN && SC_Input.iPnlFillArea != PanelAutofillArea.ALL) {
                if (Statics.oSpanWidthMax && Statics.oSpanWidthMax[sRange]) {
                    if (Statics.oSpanWidthMax[sRange][list[i].w.toString()] == -1) {
                        invalid_panel_status = true;
                    }
                } else {
                    invalid_panel_status = true;
                }
            }
            if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT) {
                invalid_panel_status = false;
            }
            panel.width(list[i].w);
            panel.height(list[i].h);
            Modul.bindEventsForModule(group);
            group.add(panel);
            group.add(border1);
            group.add(border);
            group.add(this.CanTilEver(list[i].w, list[i].h));
            group.add(this.leftInvalidPanels(list[i].w, list[i].h, invalid_panel_status));
            group.add(this.rightInvalidPanels(list[i].w, list[i].h, invalid_panel_status));
            DrawRoofForPanel.panelGroup.add(group);
            setTimeout(() => { DrawRoofForPanel.layerPanel.batchDraw();}, 1000);
        }



        // // Modul.bindEventsForModule(group);
        // var border1 = getCanvasLine({
        //     points: [1, 1, width - 1, 1, width - 1, height - 1, 1, height - 1, 1, 1],
        //     stroke: '#00ff89',
        //     strokeWidth: 2,
        //     opacity: 0,
        //     name: 'border1'
        // });
        // var border = getCanvasLine({
        //     points: [4, 4, width - 4, 4, width - 4, height - 4, 4, height - 4, 4, 4],
        //     stroke: '#00ff89',
        //     strokeWidth: 4,
        //     opacity: 0,
        //     name: 'border'
        // });
        // const sRange = AreaFinder.getAreaByModule(group.getAttrs());
        // let invalid_panel_status: boolean = false;
        // if (SC_Input.iMountSys != MountingSystem.SOL50_PREM_IN) {
        //     if (Statics.oSpanWidthMax && Statics.oSpanWidthMax[sRange]) {
        //         if (Statics.oSpanWidthMax[sRange][width.toString()] == -1) {
        //             invalid_panel_status = true;
        //         }
        //     } else {
        //         invalid_panel_status = true;
        //     }
        // }
        // if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL && SC_Input.iMountingType == MountingType.DIRECT) {
        //     invalid_panel_status = false;
        // }
        // group.add(panelmg);
        // group.add(border1);
        // group.add(border);
        // group.add(this.CanTilEver(width, height));
        // group.add(this.leftInvalidPanels(width, height, invalid_panel_status));
        // group.add(this.rightInvalidPanels(width, height, invalid_panel_status));

        // // 
        // layer.add(group);
        // //Draw panels
        // // let layer = new Konva.Layer();
        // // this.stage.add(layer);
        // let panel = AppCache.prjData.selectedPanel;
        // let scale = this.scale;
        // // Cache
        // // let rect = new Konva.Rect({
        // //     fill: 'darkblue',
        // //     x: 10,
        // //     y: 10,
        // //     width: panel.width / scale,
        // //     height: panel.height / scale
        // // });
        // // rect.cache();
        // this.panelLayer.removeChildren();
        // let panelImgHorizontal = panelImg.clone();
        // panelImgHorizontal.rotate(270);
        // panelImgHorizontal.scaleX(-1);
        // this.panelArray = [];
        // let panelIndex = 0;
        // for (let row of AppCache.invString.panelRows) {
        //     let x = row.x;
        //     for (let i = 0; i < row.panelCount; i++) {
        //         let rectClone;
        //         // let rectClone = new Konva.Rect({
        //         //     fill: AppCache.invString.panelColorEmpty,
        //         //     x: x / scale,
        //         //     y: row.y / scale,
        //         //     width: panel.width / scale,
        //         //     height: panel.height / scale
        //         // });
        //         // let rectClone = rect.clone({
        //         //     x: x / scale,
        //         //     y: row.y / scale,
        //         //     width: panel.width / scale,
        //         //     height: panel.height / scale
        //         // });

        //         if (row.horizontal) {
        //             rectClone = panelImgHorizontal.clone();
        //             rectClone.width(panel.width / scale);
        //             rectClone.height(panel.height / scale);
        //             rectClone.x(x / scale);
        //             rectClone.y(row.y / scale);
        //             x += panel.height + row.space;
        //         } else {
        //             rectClone = panelImg.clone();
        //             rectClone.width(panel.width / scale);
        //             rectClone.height(panel.height / scale);
        //             rectClone.x(x / scale);
        //             rectClone.y(row.y / scale);
        //             x += panel.width + row.space;
        //         }
        //         rectClone.setAttr("idx", panelIndex);
        //         this.panelLayer.add(rectClone);
        //         this.panelArray.push(rectClone);
        //         panelIndex++;
        //     }
        // }
        // this.panelLayer.on('mousemove', (e) => {
        //     // document.body.style.cursor = 'pointer';
        //     if (AppCache.invString.drawingEnabled && this.mouseIsDown) {
        //         let index: number = e.target.index;
        //         if (!this.panelInUse[index]) {
        //             this.addToString(index, e.target);
        //         }
        //     }
        // });
        // this.stage.on('contentMousedown.proto', (eventData) => {
        //     if (eventData.evt.buttons === 1) {
        //         // Only activate on left button
        //         this.mouseIsDown = true;
        //     }
        // });
        // this.stage.on('contentMouseup.proto', () => {
        //     this.mouseIsDown = false;
        // });
        // this.panelLayer.on('mouseout', () => {
        //     // document.body.style.cursor = 'default';
        // });
        // this.panelLayer.draw();
        // this.initStrings();
        let tEnd = +new Date();
        // console.log('time:' + (tEnd - tStart));
    }

    CanTilEver(w: number, h: number) {
        return new Konva.Line({
            points: [
                0.25 * w,
                0.25 * h,
                0.75 * w,
                0.75 * h
            ],
            stroke: Global.colCanTilEver,
            strokeWidth: 4,
            name: 'canTilEver',
            opacity: 0
        });
    }

    leftInvalidPanels(w: number, h: number, invalid_panel_status: boolean) {
        return new Konva.Line({
            points: [
                0.25 * w,
                0.25 * h,
                0.75 * w,
                0.75 * h
            ],
            stroke: Global.colInvalidPanels,
            strokeWidth: 4,
            name: 'invalidPanels',
            opacity: invalid_panel_status ? 1 : 0
        });
    }

    rightInvalidPanels(w: number, h: number, invalid_panel_status: boolean) {
        return new Konva.Line({
            points: [
                0.75 * w,
                0.25 * h,
                0.25 * w,
                0.75 * h,
            ],
            stroke: Global.colInvalidPanels,
            strokeWidth: 4,
            name: 'invalidPanels',
            opacity: invalid_panel_status ? 1 : 0
        });
    }
}